<template>
  <div class="part5">
    <img
      class="bg"
      src="https://summit-img.geekpark.net/if2021/pc/05-背景.svg"
    />
    <img
      class="img1"
      src="https://summit-img.geekpark.net/if2021/pc/大会logo-通用.svg"
    />
    <img
      class="img2"
      src="https://summit-img.geekpark.net/if2021/pc/科技创造美好.svg"
    />
  </div>
</template>

<script>
export default {
  name: "Part5",
};
</script>

<style lang="less" scoped>
.part5 {
  padding: 10vh 0vh 10vh 10vh;
  position: relative;
  margin-left: 10vh;
  .bg {
    height: 80vh;
    width: auto;
  }
  .img1 {
    height: 62vh;
    width: auto;
    position: absolute;
    top: 20vh;
    left: 0vh;
  }
  .img2 {
    height: 36vh;
    width: auto;
    position: absolute;
    top: 38.2vh;
    left: 94vh;
  }
}
</style>
